<template>
    <div>
        <v-tabs v-model="tab" background-color="primary">
            <v-tab  class="primary white--text" > Estudios socioeconómicos </v-tab>
            <v-tab  class="primary white--text" > Agregar nota </v-tab>
            <!--<v-tabs-slider color="primary"></v-tabs-slider>-->
        </v-tabs>


        <v-tabs-items v-model="tab">
            <v-tab-item  class="primary lighten-5">
                <v-card>
                    <v-toolbar flat color="primary" dark>
                        <v-toolbar-title>Estudios socioeconómicos</v-toolbar-title>

                        <v-progress-linear
                            :active="loadingPac"
                            :indeterminate="loadingPac"
                            absolute
                            bottom
                            color="green accent-4"
                        />

                    </v-toolbar>
                    <v-card-text>
                        <v-sheet>
                            <v-row>
                                <v-col sm=3 cols="12">
                                    <v-text-field
                                        v-model.number="cip"
                                        rounded
                                        filled
                                        dense
                                        type="number"
                                        label="Expediente"
                                        :readonly="loadingPac"
                                        append-outer-icon="mdi-magnify"
                                        @click:append-outer="dialogBuscaPaciente=true"
                                    />
                                </v-col>

                                <v-col sm=9 cols="12">
                                    <v-text-field
                                        v-model="pac.nombreCompleto"
                                        dense
                                        label="Nombre"
                                        readonly
                                    />
                                </v-col>

                                <v-col sm=3 cols="12">
                                    <v-text-field
                                        v-model="pac.edad"
                                        dense
                                        label="Edad"
                                        readonly
                                    />
                                </v-col>

                                <v-col sm=3 cols="12">
                                    <v-text-field
                                        v-model="pac.fechaNacimiento"
                                        dense
                                        label="Fecha de nacimiento"
                                        readonly
                                    />
                                </v-col>

                                <v-col sm=3 cols="12">
                                    <v-text-field
                                        v-model="pac.curp"
                                        dense
                                        label="C.U.R.P."
                                        readonly
                                        :rules="[value => !!value || 'Debe actualizar.']"
                                    />
                                </v-col>

                                <v-col sm=3 cols="12" class="d-flex flex-row">
                                    <v-text-field
                                        v-model="pac.otrosNivelSe"
                                        dense
                                        label="Nivel S.E."
                                        readonly
                                        append-outer-icon="mdi-pencil"
                                        @click:append-outer="abreEditaNivel"
                                    />
                                    <v-btn icon v-if="pac.otrosNivelSe" @click="imprime(cip)"><v-icon>mdi-printer</v-icon></v-btn>
                                </v-col>
                            </v-row>
                        </v-sheet>
                    </v-card-text>

                </v-card>
            </v-tab-item>

            <v-tab-item class="primary lighten-5">
                <v-card>
                        <v-toolbar flat color="primary" dark>
                        <v-toolbar-title> Agregar nota de trabajo social</v-toolbar-title>
                            <v-progress-linear
                                :active="loadingPac"
                                :indeterminate="loadingPac"
                                absolute
                                bottom
                                color="green accent-4"
                            />
                        </v-toolbar>
                        <v-card-text>
                        <v-sheet>
                            <v-row>
                                <v-col sm=3 cols="12">
                                    <v-text-field
                                        v-model.number="cipNota"
                                        rounded
                                        filled
                                        dense
                                        type="number"
                                        label="Expediente"
                                        :readonly="loadingPac"
                                        append-outer-icon="mdi-magnify"
                                        @click:append-outer="dialogBuscaPacienteNota=true"
                                        @change="buscarUltimoInternamiento"
                                    />
                                </v-col>
                                <v-col sm=9 cols="12">
                                    <v-text-field
                                        v-model="pacienteNota.nombreCompleto"
                                        dense
                                        label="Nombre"
                                        readonly
                                    />
                                </v-col>
                                <v-col sm=3 cols="12">
                                    <v-text-field
                                        v-model="pacienteNota.edad"
                                        dense
                                        label="Edad"
                                        readonly
                                    />
                                </v-col>
                                <v-col sm=3 cols="12">
                                    <v-text-field
                                        v-model="pacienteNota.fechaNacimiento"
                                        dense
                                        label="Fecha de nacimiento"
                                        readonly
                                    />
                                </v-col>
                                <v-col sm=3 cols="12">
                                    <v-text-field
                                        v-model="pacienteNota.curp"
                                        dense
                                        label="C.U.R.P."
                                        readonly
                                        :rules="[value => !!value || 'Debe actualizar.']"
                                    />
                                </v-col>
                                <div class="d-flex px-4 justify-end">
                                    <v-btn color="error" @click="limpiarCampos">
                                        Limpiar
                                    </v-btn>
                                </div>
                                <v-row>
                                    <v-col cols="12" class="mt-4" v-if="pacienteNota && pacienteNota.pacienteId">
                                        <list-notas
                                        :internamiento="ultimo"
                                        :paciente="pacienteNota.pacienteId"
                                        area="ts"
                                        />
                                    </v-col>

                                </v-row>

                            </v-row>
                        </v-sheet>
                    </v-card-text>
                </v-card>
            </v-tab-item>
        </v-tabs-items>

        <busca-paciente
            :dialogBuscaPaciente.sync="dialogBuscaPaciente"
            :paciente.sync="cip"
            :todos="true"
        />
        <datos-estudio
            :editaNivelDialog.sync="editaNivelDialog"
            :paciente="pac"
            @guardado="cargaPaciente(cip)"
        />
         <busca-paciente
            :dialogBuscaPaciente.sync="dialogBuscaPacienteNota"
            :paciente.sync="cipNota"
            :todos="true"
        />
    </div>
</template>

<script>
export default {
    props:{
        datos:Object
    },
    components:{
        'datos-estudio': () => import('@/components/tsocial/EditaNivelDialog'),
        'busca-paciente':() => import('@/components/hospital/buscaPaciente'),
        'list-notas':() => import('@/components/hospital/Notas'),
    },
    data:()=>({
        tab: 0,
        loadingPac:false,
        loadingPrint:false,
        dialogBuscaPaciente:false,
        dialogBuscaPacienteNota:false,
        pac:{},
        editaNivelDialog:false,
        cip:null,
        cipNota: null,
        ultimo:null,
        pacienteNota:{
            nombreCompleto: '',
            edad: '',
            fechaNacimiento: '',
            curp: '',
            pacienteId: null
        },
            }),

    methods:{
        abreEditaNivel(){
            if (this.pac.pacienteId){
                this.editaNivelDialog=true
            }
        },
        limpiarCampos() {
            this.cipNota = null;
            this.pacienteNota = {
            nombreCompleto: '',
            edad: '',
            fechaNacimiento: '',
            curp: '',
            pacienteId: null
            };
            this.ultimo = null;
        },
        async ultimoInternamiento(paciente){
            try{
                let req = await this.$http({
                    url:'/internamientos/ultimoInternamiento',
                    method:'GET',
                    params:{pacienteId:paciente}
                })
                console.log('Respuesta completa de /ultimoInternamiento:', req.data)
                let datos = req.data
                console.log('ultimo internamiento datos:', datos)
                //this.ultimo = datos.internamientoId
                return datos.id
            }catch(err){
                this.$store.dispatch('security/revisaError',err)
            }
        },
        async buscarUltimoInternamiento() {
            if (!this.cipNota) return
                console.log('Buscando ultimo internamiento para', this.cipNota)
            try {
                let ultimo = await this.ultimoInternamiento(this.cipNota)
                this.ultimo = ultimo
                console.log('Ultimo internamiento encontrado:', this.ultimo)

                let req = await this.$http({
                url: '/pacientes/listV2',
                method: 'GET',
                params: { id: this.cipNota }
                })
                const datos = req.data
                //console.log('Datos del paciente para nota:', datos)

                if (datos.pacienteId) {
                    this.pacienteNota = datos
                    this.pac = datos // <-- sincroniza los campos visibles
                }

                if (datos.pacienteId) {
                this.pacienteNota = datos
                } else {
                this.$swal.fire({
                    icon: 'warning',
                    title: 'No existe',
                    text: 'No se encuentran registros para el paciente ' + this.cipNota,
                })
                }

            } catch (err) {
                this.$store.dispatch('security/revisaError', err)
            }
            },

        async cargaPaciente(paciente){
            try{
                this.loadingPac=true
                let req = await this.$http({
                    url:'/pacientes/listV2',
                    method:'GET',
                    params:{id:paciente}
                })
                this.loadingPac=false
                let datos = req.data
                if (datos.pacienteId){
                    if (datos.curp){
                        let curplast = datos.curp.slice(-2)

                        if (curplast == 'XX'){
                            datos.curp=''
                        }
                    }
                    this.pac = datos
                } else {
                    this.$swal.fire({
                        icon: 'warning',
                        title: 'No existe',
                        text: 'No se encuentran registros para el paciente '+paciente,
                    })
                }
            }catch(err){
                this.loadingPac=false
                this.$store.dispatch('security/revisaError',err)
            }
        },
        async imprime(cip){
            this.loadingPrint=true
            try{
                let estce = await this.$http({
                    url:'/hospital/listEstudioSe',
                    method:'GET',
                    params:{cip:cip}
                })
                let estudio = estce.data.root[0].id

                let dt = await this.$http({
                    url: '/hospital/imprimeEstudioSe',
                    timeout: 600000,
                    method: 'GET',
                    params:{id:estudio},
                    responseType: 'arraybuffer',
                })
                this.loadingPrint=false
                let qs1 = dt.request.responseURL.split('?')
                let vars = qs1[1].split('&');
                let getVars = {};
                let tmp = '';
                vars.forEach(function(v){
                    tmp = v.split('=');
                    if(tmp.length == 2)
                    getVars[tmp[0]] = tmp[1];
                });
                
                // Crea el archivo y lo manda
                var headers = dt.headers;
                var blob = new Blob([dt.data],{type:headers['content-type']});
                var link = document.createElement('a');
                link.href = window.URL.createObjectURL(blob);
                link.download = getVars._name+'.pdf';
                link.click();
                
                
            } catch(err){
                this.loadingPrint=false
                this.$store.dispatch('security/revisaError',err)
            }
        }
        
    },
    watch:{
        cip(val){
            if (val >= 10000099){
                this.cargaPaciente(val)
            } else{
                this.pac = {}
            }
            
        },
        cipNota(val) {
    if (!val) {
      this.pacienteNota = {
        nombreCompleto: '',
        edad: '',
        fechaNacimiento: '',
        curp: '',
        pacienteId: null
      }
      this.ultimo = null
    }
  }

    },
}
</script>

<style>

</style>